<script setup>
import { t } from "@/controllerLK/AvalLocalization";
import { defineProps, defineEmits } from "vue";
import CrossIconSemi from "@/components/Icons/CrossIconSemi.vue";
import BaseNewsCard from "@/components/MapPage/MapNews/BaseNewsCard.vue";

defineProps({
  isNewsListOpened: {
    type: Boolean,
    default: false,
    required: true
  },
  newsList: {
    type: Array,
    required: true,
    default: () => []
  },
  cityName: {
    type: String,
    default: null,
    required: false,
  },
  activeFilterTypeOption: {
    type: String,
    required: true,
    validator: (value) => ["sentiment", "importance"].includes(value)
  }
});

const emit = defineEmits(["close-news-list"]);
</script>

<template>
  <aside
    v-if="isNewsListOpened"
    class="news-list"
    role="complementary"
    aria-label="Список новостей"
  >
    <header class="news-list__header">
      <h2 class="news-list__title">
        <template v-if="newsList.length > 0 && cityName">
          {{ cityName }},
        </template>
        {{ newsList.length }} {{ t('map_news_list.title') }}
      </h2>

      <button
        type="button"
        class="news-list__close"
        :aria-label="t('news.close')"
        @click="emit('close-news-list')"
      >
        <CrossIconSemi />
      </button>
    </header>

    <div class="news-list__content">
      <BaseNewsCard
        v-for="item in newsList"
        :key="item.id"
        :news-item="item"
        :active-filter-type-option="activeFilterTypeOption"
        variant="card"
        :collapsible="true"
      />
    </div>
  </aside>
</template>

<style scoped lang="scss">
@use "@/assets/style/variables.scss";

.news-list {
  position: absolute;
  right: 0;
  bottom: 14px;
  display: flex;
  flex-direction: column;
  width: 500px;
  max-height: calc(100% - 82px);
  padding: 20px;
  border-radius: 10px;
  background: var(--background-bg-secondary, #EEF1F4);
  box-shadow: 0 0 16px 0 rgba(36, 37, 40, 0.14);
  gap: 10px;
  z-index: 999;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  &__title {
    flex: 1;
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: var(--text-text-main);
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: none;
    color: var(--icon-icon-secondary);
    cursor: pointer;

    &:hover {
      color: var(--blue-blue60);
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;

    // Scrollbar стили
    &::-webkit-scrollbar {
      width: 23px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #1A64D433;
      border: 8px solid transparent;
      background-clip: padding-box;
      border-radius: 30px;
    }
  }
}
</style>